import { render, staticRenderFns } from "./gtr-event-bookmarks.vue?vue&type=template&id=596ccfe1"
import script from "./gtr-event-bookmarks.ts?vue&type=script&lang=ts&external"
export * from "./gtr-event-bookmarks.ts?vue&type=script&lang=ts&external"
import style0 from "./gtr-event-bookmarks.vue?vue&type=style&index=0&id=596ccfe1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports